<template>
	<div>
		<div class="air__utils__heading d-flex align-items-center">
			<h5>Security</h5>
		</div>

		<a-form :form="form" @submit="handleSubmit">
			<a-form-item v-bind="formItemLayout" label="Password" has-feedback>
				<a-input
					v-decorator="[
						'password',
						{
							rules: [
								{
									required: true,
									message: 'Please input your password!',
								},
								{
									validator: validateToNextPassword,
								},
							],
						},
					]"
					type="password"
				/>
			</a-form-item>
			<a-form-item
				v-bind="formItemLayout"
				label="Confirm Password"
				has-feedback
			>
				<a-input
					v-decorator="[
						'confirm',
						{
							rules: [
								{
									required: true,
									message: 'Please confirm your password!',
								},
								{
									validator: compareToFirstPassword,
									message: 'Two passwords that you enter is inconsistent!',
								},
							],
						},
					]"
					type="password"
					@blur="handleConfirmBlur"
				/>
			</a-form-item>

			<a-form-item v-bind="tailFormItemLayout">
				<a-button type="default" html-type="submit">
					Update
				</a-button>
			</a-form-item>
		</a-form>
	</div>
</template>

<script>
import { USER as USER_ACTIONS } from '@/store/actions'
import { mapActions, mapGetters } from 'vuex'
export default {
	data() {
		return {
			form: this.$form.createForm(this),

			formItemLayout: {
				labelCol: {
					xs: { span: 4 },
					sm: { span: 4 },
				},
				wrapperCol: {
					xs: { span: 12 },
					sm: { span: 12 },
				},
			},
			tailFormItemLayout: {
				wrapperCol: {
					xs: {
						span: 2,
						offset: 4,
					},
					sm: {
						span: 2,
						offset: 4,
					},
				},
			},
		}
	},
	created() {},
	methods: {
		handleSubmit(e) {
			e.preventDefault()
			this.form.validateFieldsAndScroll((err, values) => {
				if (!err) {
					this.updatePassword({
						id: this.getCurrentUser.id,
						password: values.password,
					}).then(e => {
						this.$notification.success('Password updated')
					})
				}
			})
		},
		...mapActions({ updatePassword: USER_ACTIONS.PASSWORD }),
		handleConfirmBlur(e) {
			const value = e.target.value
			this.confirmDirty = this.confirmDirty || !!value
		},
		compareToFirstPassword(rule, value, callback) {
			const form = this.form
			if (value && value !== form.getFieldValue('password')) {
				callback(new Error('Two passwords that you enter is inconsistent!'))
			} else {
				callback()
			}
		},
		validateToNextPassword(rule, value, callback) {
			const form = this.form
			if (value && this.confirmDirty) {
				form.validateFields(['confirm'], { force: true })
			}
			callback()
		},
	},
	computed: {
		...mapGetters(['getCurrentUser']),
	},
}
</script>

<style></style>
